// extracted by mini-css-extract-plugin
export default {"row":"ScreenReport_row__iv39v","img":"ScreenReport_img__SNuVM","emptyState":"ScreenReport_emptyState__XhTIz","emptyStateTitle":"ScreenReport_emptyStateTitle__f4mao"};